import { toConstructionDossierList, toDataSearch } from '../../links'
import { routing } from '../../routes'
import { SearchType } from './constants'
import DataSearchResults, { DataSearchResultsProps } from './DataSearchResults'

interface LocationDescriptorObject {
  pathname?: string | undefined
  search?: string | undefined
}
export const DEFAULT_LIMIT = 10

export interface SearchConfig {
  query: string
  to: LocationDescriptorObject
  path: string
  label: string
  type: SearchType
  component?: any
}

// This object is used to define the sort order of the search page
const SEARCH_TYPES_CONFIG: {
  [p: string]: {
    path: string
    component: React.FunctionComponent<DataSearchResultsProps>
    to: LocationDescriptorObject
    label: string
    type: SearchType
  }
} = {
  [routing.dataSearch.page]: {
    to: toDataSearch(),
    path: routing.dataSearch.path,
    label: routing.dataSearch.title,
    type: SearchType.Data,
    component: DataSearchResults,
  },
  [routing.constructionDossierList.page]: {
    to: toConstructionDossierList(),
    path: routing.constructionDossierList.path,
    label: routing.constructionDossierList.title,
    type: SearchType.Data,
    component: DataSearchResults,
  },
}

export default {
  [routing.search.page]: {
    to: toDataSearch(),
    path: routing.search.path,
    label: routing.search.title,
    type: SearchType.Search,
  },
  ...SEARCH_TYPES_CONFIG,
}
